import { createAdminClient } from '@storeo/api-client';
import { currentToken } from './authClient';

/** Client do admin interno — token de staff (role `platform-staff`) em toda chamada. */
export const api = createAdminClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8080',
  getToken: () => currentToken(),
});
